import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import EmblaCarousel from "@ucs/Components/EmblaCarousel/EmblaCarousel";
import React from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
    number = "number",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.number]: number;
    };
}

type Props = OwnProps;

interface CarouselStyles {
    titleText?: TypographyPresentationProps;
}

const carouselStyles: CarouselStyles = {
    titleText: {
        variant: "h2",
        css: css`
            margin-left: 20px;
            margin-bottom: 10px;
            font-size: 1.6em;
        `,
    },
};

const styles = carouselStyles;

const ZonesCarousel: React.FC<Props> = ({ id, fields }) => {
    const zones: string[] = [];
    for (let index = 0; index < fields.number; index++) {
        zones.push(`Content${index}`);
    }

    return (
        <StyledWrapper>
            {fields.title && <Typography {...styles.titleText}>{fields.title}</Typography>}
            <EmblaCarousel id={id} zones={zones}></EmblaCarousel>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ZonesCarousel,
    definition: {
        group: "Common",
        icon: "Carousel",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 0,
            },
            {
                name: fields.number,
                displayName: "Number of Zones",
                editorTemplate: "IntegerField",
                defaultValue: 3,
                fieldType: "General",
                isRequired: true,
                sortOrder: 1,
            },
        ],
    },
};

export default widgetModule;
